var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    staticClass: "w-full p-2 bg-white rounded-xl shadow-md",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-title', [_vm._v("Upcoming Appointment")]), _vm.data.length > 0 ? _c('div', {
    ref: "scrollContainer",
    staticClass: "log-scrollable",
    on: {
      "scroll": _vm.handleScroll
    }
  }, _vm._l(_vm.data, function (lead, index) {
    return _c('div', {
      key: index,
      staticClass: "alert alert-warning mx-1 mb-1 p-1 cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.onShowPage(lead === null || lead === void 0 ? void 0 : lead.id);
        }
      }
    }, [_c('b', [_c('feather-icon', {
      attrs: {
        "icon": "BriefcaseIcon"
      }
    }), _c('span', {
      staticClass: "text-black"
    }, [_vm._v(_vm._s(lead.title))])], 1), _c('p', {
      staticClass: "mt-1"
    }, [_c('feather-icon', {
      attrs: {
        "icon": "ClockIcon"
      }
    }), _vm._v(" " + _vm._s(_vm.formatDate(lead.next_contact_date)) + " ")], 1)]);
  }), 0) : _c('div', {
    staticClass: "text-center"
  }, [_c('b', [_vm._v("No Data Found")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }